export default {
  note: {
    title: 'Note speciale:',
    description: 'Vom încerca să satisfacem cererile, dar nu putem face modificări care afectează prețul.',
    placeholder: 'Adaugă o cerere specială',
  },
  buttons: {
    add: '+ Adaugă articol',
    update_item: 'Actualizează',
    add_to_card: 'Adaugă în coș',
  },
  alcohol_warning: 'Acesta este un articol cu restricție de vârstă.',
  caffeine_warning:
    'Conținut ridicat de cofeină. Nu se recomandă copiilor sau femeilor gravide ori care alăptează.{{value}}',
  error_messages: {
    product_unavailable: 'Epuizat!',
    item_not_added: 'Articolul nu a putut fi adăugat. Încearcă din nou.',
  },
  success_messages: {
    item_added: 'Articol adăugat cu succes',
  },
};
